import React from 'react';
import { Box, Container, Typography, Grid, Link, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';

const FooterSection = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <Box 
      sx={{ 
        background: '#000000', 
        py: 10, 
        mt: 0,
        borderTop: '1px solid rgba(255, 255, 255, 0.08)'
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 4, md: 8 }}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ color: '#ffffff', mb: 3, fontWeight: 800, fontSize: '1.25rem', letterSpacing: '-0.02em' }}>
              FutureSense
            </Typography>
            <Typography sx={{ color: theme.palette.text.secondary, mb: 2, lineHeight: 1.6 }}>
              The AI-first operational stack for independent practitioners. 
              Modern scheduling, CRM, and automation.
            </Typography>
          </Grid>
          
          <Grid item xs={12} md={2}>
            <Typography variant="subtitle2" sx={{ color: '#ffffff', mb: 3, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1 }}>
              Product
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              {[
                { label: 'Features', path: ROUTES.FEATURES },
                { label: 'Pricing', path: ROUTES.PRICING },
                { label: 'Free Events', path: ROUTES.EVENTS },
                { label: 'vs Mindbody', path: ROUTES.VS_MINDBODY },
                { label: 'Directory', path: ROUTES.DIRECTORY },
                { label: 'Blog', path: ROUTES.BLOG }
              ].map((link) => (
                <Link 
                  key={link.label}
                  component="button"
                  onClick={() => navigate(link.path)}
                  sx={{ 
                    color: theme.palette.text.secondary, 
                    textAlign: 'left', 
                    textDecoration: 'none',
                    fontSize: '0.9rem',
                    transition: 'color 0.2s ease',
                    '&:hover': { color: '#ffffff' }
                  }}
                >
                  {link.label}
                </Link>
              ))}
            </Box>
          </Grid>
          
          <Grid item xs={12} md={2}>
            <Typography variant="subtitle2" sx={{ color: '#ffffff', mb: 3, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1 }}>
              Resources
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              {[
                { label: 'FAQ', path: ROUTES.FAQ },
                { label: 'Support', path: 'mailto:support@futuresenseai.com' }
              ].map((link) => (
                <Link 
                  key={link.label}
                  component={link.path.startsWith('mailto') ? 'a' : 'button'}
                  href={link.path.startsWith('mailto') ? link.path : undefined}
                  onClick={link.path.startsWith('mailto') ? undefined : () => navigate(link.path)}
                  sx={{ 
                    color: theme.palette.text.secondary, 
                    textAlign: 'left', 
                    textDecoration: 'none',
                    fontSize: '0.9rem',
                    '&:hover': { color: '#ffffff' }
                  }}
                >
                  {link.label}
                </Link>
              ))}
            </Box>
          </Grid>
          
          <Grid item xs={12} md={2}>
            <Typography variant="subtitle2" sx={{ color: '#ffffff', mb: 3, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1 }}>
              Legal
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              {[
                { label: 'Privacy', path: ROUTES.PRIVACY },
                { label: 'Terms', path: ROUTES.TERMS }
              ].map((link) => (
                <Link 
                  key={link.label}
                  component="button"
                  onClick={() => navigate(link.path)}
                  sx={{ 
                    color: theme.palette.text.secondary, 
                    textAlign: 'left', 
                    textDecoration: 'none',
                    fontSize: '0.9rem',
                    '&:hover': { color: '#ffffff' }
                  }}
                >
                  {link.label}
                </Link>
              ))}
            </Box>
          </Grid>
        </Grid>
        
        <Box 
          sx={{ 
            mt: 10, 
            pt: 4, 
            borderTop: '1px solid rgba(255, 255, 255, 0.05)',
            textAlign: 'center'
          }}
        >
          <Typography variant="caption" sx={{ color: theme.palette.text.disabled, display: 'block' }}>
            © 2026 FutureSense AI. All rights reserved. Built for practitioners.
          </Typography>
          <Typography variant="caption" sx={{ color: theme.palette.text.disabled, display: 'block', mt: 1, fontSize: '0.7rem' }}>
            This site is protected by reCAPTCHA and the Google{' '}
            <Link href="https://policies.google.com/privacy" target="_blank" rel="noopener" sx={{ color: 'inherit', textDecoration: 'underline' }}>Privacy Policy</Link>
            {' '}and{' '}
            <Link href="https://policies.google.com/terms" target="_blank" rel="noopener" sx={{ color: 'inherit', textDecoration: 'underline' }}>Terms of Service</Link>
            {' '}apply.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default FooterSection;